import { render, staticRenderFns } from "./precio.vue?vue&type=template&id=affb6cc4&scoped=true&"
import script from "./precio.vue?vue&type=script&lang=js&"
export * from "./precio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb6cc4",
  null
  
)

export default component.exports